import React from "react";
import {verifyPayment} from "../../../redux/slices/paymentVerificationSlice";
import {useDispatch} from "react-redux";
import ProductItem from "./ProductItem";
import CustomButton from "../../../components/CustomButton";
import {PAY_FOR} from "../../../constants/commons";
import ConsultationItem from "./ConsultationItem";
import CampaignItem from "./CampaignItem";
import {capitalizeFirstLetter} from "../../../helpers/stringHelper";
import CustomIcon from "../../../components/CustomIcon";

function PaymentItem({payment}) {
  const dispatch = useDispatch()


  const verifyPaymentAction = (paymentItem) => {
    dispatch(verifyPayment({
      paymentItemId: paymentItem.id, verificationPayload: {
        pay_through: "ESEWA",
        pay_for: payment.pay_for,
        reference_id: paymentItem.reference_id
      }
    }))
  }

  const paymentGist = (payFor) => {
    switch (payFor) {
      case PAY_FOR[0].value:
        return <ConsultationItem doctor={payment.doctor}/>
      case PAY_FOR[1].value:
        return payment.products.map((product) => {
          return <ProductItem product={product}/>
        })
      case PAY_FOR[2].value:
        return <CampaignItem campaign={payment.campaign}/>
      default:
    }
  }

  return (
    <div key={payment} className="custom-card text-rand-100">
      <div>
        <div className="flex justify-between flex-col items-start sm:flex-row sm:items-center">
          <div className="font-medium sm:text-xl">Reference Id: {payment.reference_id}</div>
          <div className="font-medium sm:text-2xl">Total: {payment?.price ?? "N/A"}</div>
        </div>
        <h2 className="font-light text-sm sm:text-base">{payment.created_at}</h2>
      </div>
      <div>
        <div className="flex flex-wrap py-2">
          {paymentGist(payment.pay_for)}
        </div>
      </div>
      <div className="flex justify-between flex-col space-y-2 items-start sm:flex-row sm:items-center sm:space-y-0">
        <div className="text-sm">Payment Status: <span className={`${payment.payment_status === "NOT_FOUND" ? "text-error-500" : "text-primary-500"} font-medium`}>{payment.payment_status === "NOT_FOUND" ? "Transaction not found" : "Transaction Successful"}</span></div>
        <CustomButton onClick={() => verifyPaymentAction(payment)}>Verify Payment</CustomButton>
      </div>
    </div>
  )
}

export default PaymentItem